import React from 'react';
import { connect } from '../../connect';
import { LoadingIndicator } from '../loading-indicator';
import { register, IMailingListCheckbox } from '../../actions';
import '../../styles/_sign-in-register.less';
import './index.less';
import { IAuthState } from '../../reducers/auth-reducers';
import { IActionDispatch } from '../../actions/action-types';

function mapStateToProps({ auth }) {
	return { auth };
}

interface IRegisterFormProps {
	dispatch?: IActionDispatch;
	auth?: IAuthState;
	location: URL;
	emailOptInDefault?: boolean;
	registerUrl?: string;
	className?: string;
}

interface IRegisterFormState {
	email: string;
	emailOptIn: boolean;
	emailOptInPartners: boolean;
	emailOptInDefault?: boolean;
	isRegistering: boolean;
	name: string;
	password: string;
}

@connect(mapStateToProps)
export class RegisterForm extends React.Component<IRegisterFormProps, IRegisterFormState> {
	state: IRegisterFormState = {
		email: '',
		emailOptIn: false,
		emailOptInPartners: false,
		isRegistering: false,
		name: '',
		password: '',
	};

	componentDidMount() {
		if (this.props.emailOptInDefault) {
			this.setState({ emailOptIn: true, emailOptInPartners: true });
		}
	}

	componentWillReceiveProps = (nextProps: IRegisterFormProps) => {
		const emailOptInDefault = nextProps.emailOptInDefault;
		this.setState({
			emailOptInDefault,
		});
	};

	handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const nextState = {};
		nextState[event.target.name] = event.target.value;
		this.setState(nextState);
	};

	handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const emailOptIn = event.target.name === 'emailOptIn' ? !this.state.emailOptIn : this.state.emailOptIn;
		const emailOptInPartners =
			event.target.name === 'emailOptInPartners' ? !this.state.emailOptInPartners : this.state.emailOptInPartners;
		this.setState({
			emailOptIn,
			emailOptInPartners,
		});
	};

	handleRegister = (event: React.FormEvent) => {
		const { name, email, password, emailOptInDefault, emailOptIn, emailOptInPartners } = this.state;
		const { auth, dispatch } = this.props;
		event.preventDefault();
		if (auth && !auth.isProcessing) {
			this.setState({
				isRegistering: true,
			});
			const checkboxes: IMailingListCheckbox[] = [
				{
					data: '44593', // Faithlife TV
					checked: emailOptIn,
					defaultChecked: emailOptInDefault || false,
				},
				{
					data: '24754', // Faithlife Partners
					checked: emailOptInPartners,
					defaultChecked: emailOptInDefault || false,
				},
			];
			if (dispatch) {
				dispatch(register(name, email, password, checkboxes)).catch(() => null);
			}
		}
	};

	renderRegisterError = (error?: string | null) => {
		if (!error) {
			return null;
		}
		this.setState({
			isRegistering: false,
		});
		const {
			location: { pathname },
			auth,
		} = this.props;
		if (pathname === '/register') {
			return <div className="error-text">{auth && auth.error}</div>;
		}
		return <div>{auth && auth.error}</div>;
	};

	render() {
		const { registerUrl, auth } = this.props;
		const { emailOptIn, emailOptInPartners, isRegistering } = this.state;

		return isRegistering ? (
			<LoadingIndicator />
		) : (
			<form className="register-form" method="post" action={registerUrl} onSubmit={this.handleRegister}>
				{this.renderRegisterError(auth && auth.error)}
				<input type="text" placeholder="Name" name="name" autoFocus onChange={this.handleInputChange} />
				<input type="email" placeholder="Email" name="email" onChange={this.handleInputChange} />
				<input type="password" placeholder="Password" name="password" onChange={this.handleInputChange} />
				<div className="opt-in-section">
					<label htmlFor="emailOptIn" className="opt-in-checkbox">
						<input
							id="emailOptIn"
							name="emailOptIn"
							type="checkbox"
							checked={emailOptIn}
							onChange={this.handleCheckboxChange}
						/>
						<span>Sign me up to hear about news and special offers from Faithlife.</span>
					</label>
					<label htmlFor="emailOptInPartners" className="opt-in-checkbox">
						<input
							id="emailOptInPartners"
							name="emailOptInPartners"
							type="checkbox"
							checked={emailOptInPartners}
							onChange={this.handleCheckboxChange}
						/>
						{/* TODO: Fix this the next time the file is edited. */}
						{/* eslint-disable-next-line react/no-unescaped-entities */}
						<span>Send me relevant offers from Faithlife's trusted partners.</span>
					</label>
				</div>
				{/* TODO: Fix this the next time the file is edited. */}
				{/* eslint-disable-next-line react/no-unescaped-entities */}
				<span className="required-text">
					By registering for an account, you agree to Faithlife&#39;s
					{/* TODO: Fix this the next time the file is edited. */}
					{/* eslint-disable-next-line react/no-unescaped-entities */}{' '}
					<a href="https://faithlife.com/terms">Terms of Service</a> and{' '}
					<a href="https://faithlife.com/privacy">Privacy Policy</a>.
				</span>
				<button type="submit" disabled={(auth && auth.isProcessing) || isRegistering}>
					Create account
				</button>
			</form>
		);
	}
}
